<template>
    <v-card tile flat style="height:100%;">
        <v-card-text>
            <div style="text-align:left; margin:0.5rem;margin-bottom:1.5rem">
                <div class="headline">Data converters</div>
                <div class="body-1">Data converters are small pre-defined logic routines needs to convert data sent in non-standard format (e.g LoRa, Sigfox).</div>
            </div>
            <v-layout row-wrap>
                <v-flex xs12 sm12 md12 >
                  <itemlist 
                    title="Data converters"
                    :headers="[
                        {text:'Data converter',value:'label'},
                        {text:'Create timestamp',value:'createTimestamp'},
                    ]" :values="mappedDataConverters" v-on:selected="dataConverter=$event;"
                  ></itemlist>
                </v-flex>
            </v-layout>
        </v-card-text>


        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
                dark icon class="blue"
                v-on:click="$store.dispatch('deviceProfiles/fetchDataConverters')"
            >
                <v-icon>sync</v-icon>
            </v-btn>
        </v-card-actions>

    </v-card>   


</template>
<script>
import { mapState } from 'vuex';

export default {

    components:{
        itemlist: require('../../ItemList').default,
        editor: require('vue2-ace-editor'),
    },
    
    props:{
        theme:String
    },

    data(){
        return {
            dataConverter: null,
        }
    },

    computed:{
        ...mapState(
            {
                lastOperationMessage:'lastOperationMessage',
                lastOperationSuccess:'lastOperationSuccess',
                operationInProcess:'operationInProcess',
                operationInProcessMessage: 'operationInProcessMessage',
                deviceProfiles: state => state.deviceProfiles.deviceProfiles,
                dataConverters: state => state.deviceProfiles.dataConverters,
                apiKeys: state => state.apiKeys.apiKeys,
                appMetadata: state => state.metadata.models.views
            }
        ),

        mappedDataConverters(){
          return this.dataConverters.map( dc => { return { label: dc.label, updateTimestamp: dc.updateTimestamp || new Date(0), createTimestamp: dc.createTimestamp || new Date(0) } })
        }
    },
}
</script>
